import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useShiftDoublesEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.SHIFT_DOUBLES, { defaultValue: false });
}
